import API from '../API';

export const fetchPost = async slug => {
  try {
    return await API.posts.read(
      { slug },
      {
        formats: 'html',
        include: 'authors',
      }
    );
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
    return undefined;
  }
};

export default null;



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/SinglePost/utils.js